import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DatePickerDirective, IDatePickerDirectiveConfig, ISelectionEvent } from 'ng2-date-picker';
import * as moment from 'moment';
import { Moment } from 'moment';

@Component({
  selector: 'app-data-filter-date',
  templateUrl: './data-filter-date.component.html',
  styleUrls: ['./data-filter-date.component.scss']
})
export class DataFilterDateComponent implements OnInit, OnChanges {

  @ViewChild('datePicker', { static : true }) datePicker: DatePickerDirective;

  @Input() labelKey: string;
  @Input() placeholderKey: string;
  @Input() model: Moment;
  @Input() maxDate: Moment;
  @Input() minDate: Moment;
  @Input() disabled = false;
  @Input() required = false;

  @Output() modelChange = new EventEmitter<Moment>();

  public config: IDatePickerDirectiveConfig;
  public modelString: string;
  private defaultFormat = 'YYYY-MM-DD';

  public ngOnInit(): void {
    this.config = {
      appendTo: 'body',
      drops: 'down',
      firstDayOfWeek: 'mo',
      format: this.defaultFormat,
      max: this.addOffsetToDate(this.maxDate),
      min: this.addOffsetToDate(this.minDate),
      disableKeypress: true,
      unSelectOnClick: true,
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.model) {
      if (changes.model.currentValue) {
        this.modelString = changes.model.currentValue.format(this.configFormatOrDefault());
      } else {
        this.modelString = null;
      }
    }

    if (!this.config) { return; }

    if (changes.minDate || changes.maxDate) {
      this.updateConfig();
      this.checkCurrentValueIsLegal();
    }

    if (changes.disabled && this.disabled) {
      this.modelString = null;
      this.change();
    }
  }

  configFormatOrDefault(): string {
    if (this.config?.format) {
       return this.config.format;
    } else {
      return this.defaultFormat;
    }
  }

  updateConfig() {
    this.config.max = this.addOffsetToDate(this.maxDate);
    this.config.min = this.addOffsetToDate(this.minDate);

    this.config = { ...this.config };
  }

  change() {
    if (this.modelString) {
      this.model = moment(this.modelString, this.config.format);
      this.modelChange.emit(this.model);
    } else if (this.model) {
      this.model = null;
      this.modelChange.emit(this.model);
    }
  }

  select(event: ISelectionEvent) {
    if (event.type === 'selection' && moment(event.date).isSame(this.model ? this.model : null)) {
        this.eraseModel();
    } else if (event.type === 'selection' && this.modelString && event.date !== '') {
      this.model = moment(this.modelString, this.config.format);
      this.modelChange.emit(this.model);
    }
  }

  noModel(): boolean {
    return !this.modelString && !this.model;
  }

  private checkCurrentValueIsLegal() {
    if (this.noModel()) { return; }

    const valueToCheck = moment.utc(this.modelString, this.config.format)
    if (this.config.max && valueToCheck.isAfter(this.config.max) || this.config.min && valueToCheck.isBefore(this.config.min)) {
      console.warn(`current value ${this.model} is illegal. Nullifyng it.`)
      this.eraseModel();
    }
  }

  private eraseModel() {
    this.modelString = null;
    this.model = null;
    this.modelChange.emit();
  }

  /* ng2-date-picker version 10.0.1 includes a bad offset in minDate/maxDate config
  * This is a workaround to cancel the timezone effect */
  private addOffsetToDate(date: moment.Moment) {
    return date ? date.utcOffset(0, true) : date;
  }
}
